<script setup lang="ts">
import { useSessionStore, useUserStore } from '../../../stores';
import { Session } from '../../../types/session';
import { UserRole } from '../../../types/user';
import StudentPractice from './StudentPractice.vue';
import TeacherPractice from './TeacherPractice.vue';

const sessionStore = useSessionStore()
const user = useUserStore()

</script>

<template>
    <template v-if="sessionStore.classContent?.[Session.practice]">
        <TeacherPractice v-if="user.userRole === UserRole.teacher" />
        <StudentPractice v-if="user.userRole === UserRole.student" />
    </template>
</template>